"use client";

import { useEffect, useRef, useState } from "react";
import { Clock, Globe, Shield, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Metric = {
  icon: "zap" | "shield" | "globe" | "clock";
  value: number;
  suffix: string;
  prefix: string;
  decimals: number;
  display: string;
  label: string;
  detail: string;
};
const metrics: Metric[] = [{
  icon: "zap",
  value: 100,
  suffix: "%",
  prefix: "",
  decimals: 0,
  display: "100%",
  label: "Social Reach",
  detail: "Maximale zichtbaarheid voor jouw merk"
}, {
  icon: "shield",
  value: 24,
  suffix: "/7",
  prefix: "",
  decimals: 0,
  display: "24/7",
  label: "Content Support",
  detail: "Altijd actief en betrokken bij je doelgroep"
}, {
  icon: "globe",
  value: 500,
  suffix: "+",
  prefix: "",
  decimals: 0,
  display: "500+",
  label: "Campagnes",
  detail: "Succesvolle projecten voor onze klanten"
}, {
  icon: "clock",
  value: 10,
  suffix: "x",
  prefix: "",
  decimals: 0,
  display: "10x",
  label: "Groei",
  detail: "Versnelde resultaten door slimme strategie"
}];
function iconFor(name: Metric["icon"]) {
  if (name === "zap") return Zap;
  if (name === "shield") return Shield;
  if (name === "globe") return Globe;
  return Clock;
}
function AnimatedCounter({
  metric,
  start,
  index
}: {
  metric: Metric;
  start: boolean;
  index: number;
}) {
  const [value, setValue] = useState(0);
  const rafRef = useRef<number | null>(null);
  useEffect(() => {
    if (!start) return;
    const duration = 1800;
    const startTime = performance.now();
    const from = 0;
    const to = metric.value;
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(from + (to - from) * eased);
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [start, metric.value]);
  const formatted = metric.decimals > 0 ? value.toFixed(metric.decimals) : Math.round(value).toString();
  return <span data-index={index} className="bg-clip-text text-transparent" style={{
    backgroundImage: "linear-gradient(135deg, #f97316 0%, #ea580c 50%, #c2410c 100%)"
  }}>
      {metric.prefix}
      {formatted}
      {metric.suffix}
    </span>;
}
export default function TechnicalMetricsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.25
  });
  return;
}